export type WriteOffRebuildProgress = {
  total: number;
  completed: number;
  errors: number;
  currentOrderId: number | null;
};

export async function rebuildWriteOffsWithProgress(
  orderIds: number[],
  rebuild: (orderId: number) => Promise<void>,
  onProgress: (progress: WriteOffRebuildProgress) => void
): Promise<void> {
  const progress: WriteOffRebuildProgress = {
    total: orderIds.length, completed: 0, errors: 0, currentOrderId: null,
  };
  onProgress({ ...progress });
  for (const orderId of orderIds) {
    progress.currentOrderId = orderId;
    onProgress({ ...progress });
    try {
      await rebuild(orderId);
    } catch (error) {
      progress.errors++;
      onProgress({ ...progress });
      throw error;
    }
    progress.completed++;
    progress.currentOrderId = null;
    onProgress({ ...progress });
  }
}
